window.addEventListener('DOMContentLoaded', () => {
    selectCastomInit();
});
//* Сортировка в каталоге (select)
function selectCastomInit() {
    $('.v1-sorting__list').css('max-height', 'unset');
    $('.v1-sorting__list').attr('data-height', $('.v1-sorting__list').outerHeight())
    $('.v1-sorting__list').attr('style', '');
}

$(document).ready(function () {

    $('body').on('click', '.v1-sorting__chosen', function (e) {
        e.stopPropagation();
        let height = $(this).closest('.v1-sorting__box').find('.v1-sorting__list').attr('data-height');

        if (!$(this).hasClass('opened')) {

            $(this).addClass('opened');
            $(this).closest('.v1-sorting__box').addClass('opened');
            $(this).closest('.v1-sorting__box').find('.v1-sorting__list').css('max-height', height + 'px');

            if ( window.innerWidth < 768 ) {
                // $('.header').addClass('hidden-index');
                // $('#wrapper').addClass('noscroll');
                window.NoScroll.show(true);
            }

        } else {
            $(this).removeClass('opened');
            $(this).closest('.v1-sorting__box').removeClass('opened');
            $(this).closest('.v1-sorting__box').find('.v1-sorting__list').attr('style', '');

            if ( window.innerWidth < 768 ) {
                // $('.header').removeClass('hidden-index');
                // $('#wrapper').removeClass('noscroll');
                window.NoScroll.hide();
            }
        }
    });

    $('body').on('click', '.v1-sorting__value', function () {
        let value = $(this).text();
        let sort = $(this).attr('data-sort');

        $(this).find('option').prop('selected', true);
        $('.v1-sorting__chosen').text(value)
        $('.v1-sorting__box').removeClass('opened')
        $('.v1-sorting__chosen').removeClass('opened')
        $('.v1-sorting__list').attr('style', '')
        document.cookie = encodeURIComponent('SORT_PAGE') + '=' + encodeURIComponent(sort) + '; path=/';
    });

    $('.v1-sorting__box').mouseleave(function () {
        $('.v1-sorting__box').removeClass('opened')
        $('.v1-sorting__chosen').removeClass('opened')
        $('.v1-sorting__list').attr('style', '')
    });

    if ( window.innerWidth < 767 ){

        $('body').on('click', '.v1-sorting__list', function (e) {
            e.stopPropagation();
        });

        $('body').on('click', '.v1-sorting__box', function () {
            $(this).removeClass('opened');
            $(this).find('.v1-sorting__chosen').removeClass('opened');
            $(this).find('.v1-sorting__list').attr('style', '');
            // $('.header').removeClass('hidden-index');
            // $('#wrapper').removeClass('noscroll');
            window.NoScroll.hide();
        });
    }


    // * Фильтры со скидкой
    $('body').on('click', '.section-goods__discounts-value', function () {
        let sale = $(this).attr('data-sale');

        $('.section-goods__discounts-value').each(function () {
            if (sale != $(this).attr('data-sale'))
                $(this).removeClass('active');
        });

        if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            document.cookie = encodeURIComponent('SALE_PAGE') + '=' + encodeURIComponent(sale) + '; path=/';
        } else {
            $(this).removeClass('active');
            document.cookie = encodeURIComponent('SALE_PAGE') + '=' + encodeURIComponent(0) + '; path=/';
        }

    });
    $('.menu__link').click(function () {
        document.cookie = encodeURIComponent('SALE_PAGE') + '=' + encodeURIComponent(0) + '; path=/';
    });
    $('.header__logo').click(function () {
        document.cookie = encodeURIComponent('SALE_PAGE') + '=' + encodeURIComponent(0) + '; path=/';
    });

    // * START  ( Ajax) Фильтры по скидки и сортировка в каталоге
    $('body').on('click', '.v1-sorting__li ', function () {
        let id = $('.smartfilter label').attr('for');
        window.smartFilter.click(BX(id));
    });

    $('body').on('click', '.section-goods__discounts-value', function () {
        let id = $('.smartfilter label').attr('for');
        window.smartFilter.click(BX(id));
    });
    // clear filter
    $('body').on('click', '.clear-filter', function () {
        let url = $(this).attr('data-url');
        let filter = document.querySelector('.k1-filter');
        let filterPlelod = document.querySelector('.filter-preloder');
        filter.style.cssText = 'opacity: 0.5;';
        filterPlelod.style.display = "block";

        history.pushState(null, null, url);
        document.cookie = encodeURIComponent('SALE_PAGE') + '=' + encodeURIComponent(0) + '; path=/';
    });
    // * AJAX Click detail
    $('body').on('click','div.product-item-image-wrapper', function () {
        window.location.pathname = $(this).attr('data-href');
    });
    $('body').on('click', '.v1-detail-click', function () {
        window.location.pathname = $(this).attr('data-href');

    });
    // * END

});



//? AJAX CATALOG FILTER


//? Preloder ajax
BX.ready(function () {

    BX.addCustomEvent('onAjaxSuccess', function (node) {
        if ($(node).find('.v1-sorting__list').length > 0) {
            selectCastomInit();
        }

        if ($(node).find('.main-poster__slider').length > 0) {
            var mainBigPoster = new Swiper('.main-poster__slider.swiper-container', {
                loop: true,
                direction: 'horizontal',
                slidesPerView: 1.05,
                speed: 700,
                spaceBetween: 10,
                pagination: {
                    el: '.swiper-pagination.main-poster__pagination',
                    clickable: true
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 1,
                        slidesPerScroll: 1,
                    },
                    1199: {
                        slidesPerView: 1.05,
                        slidesPerScroll: 1,
                    }
                }
            });
        }

        if ($(node).find('.catalog-recommend__slider').length > 0) {
            let recommendSlider = new Swiper('.catalog-recommend__slider.swiper-container', {
                slidesPerView: 4,
                slidesPerScroll: 4,
                slidesPerGroup: 4,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next.catalog-recommend__next',
                    prevEl: '.swiper-button-prev.catalog-recommend__prev',
                },
                pagination: {
                    el: '.swiper-pagination.catalog-recommend__pagination',
                    clickable: true
                },
                breakpoints: {
                    100: {
                        slidesPerView: 1,
                        slidesPerScroll: 1,
                        slidesPerGroup: 1,
                    },
                    400: {
                        slidesPerView: 2,
                        slidesPerScroll: 2,
                        slidesPerGroup: 2,
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerScroll: 3,
                        slidesPerGroup: 3,
                    },
                    1199: {
                        slidesPerView: 4,
                        slidesPerScroll: 4,
                        slidesPerGroup: 4,
                    }
                },
            });
        }

        if ($(node).find('.catalog-viewed__slider').length > 0) {
            let viewedSlider = new Swiper('.catalog-viewed__slider.swiper-container', {
                slidesPerView: 4,
                slidesPerScroll: 4,
                slidesPerGroup: 4,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next.catalog-viewed__next ',
                    prevEl: '.swiper-button-prev.catalog-viewed__prev',
                },
                pagination: {
                    el: '.swiper-pagination.catalog-viewed__pagination',
                    clickable: true
                },
                breakpoints: {
                    100: {
                        slidesPerView: 1,
                        slidesPerScroll: 1,
                        slidesPerGroup: 1,
                    },
                    400: {
                        slidesPerView: 2,
                        slidesPerScroll: 2,
                        slidesPerGroup: 2,
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerScroll: 3,
                        slidesPerGroup: 3,
                    },
                    1199: {
                        slidesPerView: 4,
                        slidesPerScroll: 4,
                        slidesPerGroup: 4,
                    }
                },
            });
        }

        if ($(node).find('a[data-href]').length > 0) {
            $('a[data-href]').each(function () {
                $(this).attr('href', $(this).attr('data-href'));
                $(this).removeAttr('data-href');
            });
        }

        if ($(node).find('.good-item.can-hover').length > 0) {
            document.querySelectorAll('.good-item.can-hover').forEach(elem => {
                elem.addEventListener('mouseleave', function () {
                    window.k1ScriptCatalog.hoverOut();
                })
            });
        }

        if ($(node).find('.v1-sorting__box').length > 0) {
            $('.v1-sorting__box').mouseleave(function () {
                $('.v1-sorting__box').removeClass('opened')
                $('.v1-sorting__chosen').removeClass('opened')
                $('.v1-sorting__list').attr('style', '')
            });
        }

        if ($(node).find('.section-goods__title-mobile').length > 0) {
            $('body').css('overflow','auto');
        }

        if (window.innerWidth < 767) window.NoScroll.hide()

    });


    const loader = document.querySelector('.pWrap');

    BX.showWait = function (node, msg) {
        if( window.innerWidth > 991)
        if (node && typeof node !== "string") {
            if (node.querySelector('.k1-filter') !== null) {
                let filter = document.querySelector('.k1-filter');
                let filterPlelod = document.querySelector('.filter-preloder');
                filter.style.opacity = '0.5';
                filter.style.pointerEvents = "none";
                filterPlelod.style.display = "block";
            } else {
                BX.style(loader, 'display', 'none');
                BX.addClass(loader, 'ajax-preloader--animated');
            }
        }
    };

    BX.closeWait = function (node, msg) {
        if( window.innerWidth > 991)
        if (node && typeof node !== "string") {
            if (node.querySelector('.k1-filter') !== null) {
                let filter = document.querySelector('.k1-filter');
                let filterPlelod = document.querySelector('.filter-preloder');
                filter.style.cssText = '';
                filterPlelod.style.display = "none";
            } else {
                BX.style(loader, 'display', 'none');
                BX.removeClass(loader, 'ajax-preloader--animated');
            }
        }
    };
});